import diaInfADI from '@/sui/data/sheets/edit/cfg/diaInfADI'
import patient from '@/sui/data/sheets/edit/patient'
import bact from '@/sui/data/sheets/edit/bact'
import multi from '@/sui/data/sheets/edit/multi'

import {
  fromField,
  bactDistribution,
  moDistribution,
  locDistribution
} from '@/sui/data/caracteristics/tools'

function diaInfKtDistribution (e) {
  const type = diaInfADI.accessSite.v2.config.values.find(
    v => v.code === e
  ).value

  return [
    { f: `kt_${e}_uses`, t: `${type}`, h: true },
    fromField(`kt_${e}_installSite`, bact.insertionSite.full, 9),
    fromField(`kt_${e}_uses`, diaInfADI.uses.v2),
    fromField(`kt_${e}_incidents`, diaInfADI.incidents.v2),
    fromField(`kt_${e}_unrelatedManip`, diaInfADI.unrelatedManip.v2),
    fromField(`kt_${e}_useEnded`, diaInfADI.useEnded.v2, 9),
    fromField(`kt_${e}_ablated`, diaInfADI.ablated.v2, 9),
    { f: `kt_${e}_lapse`, t: `Durée de cathétérisme`, minimizeDecimalScale: true },
    fromField(`kt_${e}_installReason`, diaInfADI.installReason.v2, 9),
    fromField(`kt_${e}_tunneled`, diaInfADI.tunneled.v2, 9),
    fromField(`kt_${e}_siteChanges`, diaInfADI.siteChanges.v2, 9),
    fromField(`kt_${e}_antibiopr`, diaInfADI.antibiopr.v2, 9),
    {
      f: `kt_${e}_installLock`,
      t: `Pose`,
      h: true
    },
    fromField(`kt_${e}_installLock`, diaInfADI.lock.install.v2[0], 9),
    fromField(`kt_${e}_installCap`, diaInfADI.lock.install.v2[1], 9),
    {
      f: `kt_${e}_disconnectLock`,
      t: `Retrait`,
      h: true
    },
    fromField(`kt_${e}_disconnectLock`, diaInfADI.lock.disconnect.v2[0], 9),
    fromField(`kt_${e}_disconnectCap`, diaInfADI.lock.disconnect.v2[1], 9)
  ]
}

export default function (estb, year) {
  return [
    ...locDistribution('', 'patients', { estb: estb, year: year }),
    {
      title: 'Caractéristiques des patients',
      key: 'pat',
      list: [
        { f: `agey`, t: 'Âge (en années)', minimizeDecimalScale: true },
        fromField(`sex`, patient.sex, 9),
        fromField('hemodiafiltr', diaInfADI.hemodiafiltr, 9),
        fromField('treatedDiab', diaInfADI.treatedDiab, 9),
        fromField('immuno', diaInfADI.immuno, 9),
        fromField('hygiene', diaInfADI.hygiene, 9),
        fromField('previousInfect', diaInfADI.previousInfect, 9),
        fromField('previousBact', diaInfADI.previousBact, 9),
        fromField('toxico', diaInfADI.toxico, 9),
        fromField('vih', diaInfADI.vih, 9),
        fromField('vhc', diaInfADI.vhc, 9),
        fromField('height', diaInfADI.height),
        fromField('weight', diaInfADI.weight),
        fromField('ferritinaemia', diaInfADI.ferritinaemia),
        fromField('saturation', diaInfADI.saturation),
        fromField('hemoglobin', diaInfADI.hemoglobin),
        fromField('albumin', diaInfADI.albumin),
        fromField('creatinine', diaInfADI.creatinine),
        fromField('dialNumber', diaInfADI.dialNumber),
        fromField('cardioVascPb', diaInfADI.cardioVascPb, 9),
        fromField('surgery', diaInfADI.surgery, 9),
        fromField('transfusions', diaInfADI.transfusions),
        fromField('exitReason', diaInfADI.exitReason, 9),
        fromField('covidStatus', multi.covidStatus.exit, 9)
      ]
    },
    {
      title: `Caractéristiques des sites d'accès`,
      key: 'kt',
      list: [
        fromField('kt_type', diaInfADI.accessSite.v2),
        fromField('kt_uses', diaInfADI.uses.v2),
        fromField('kt_incidents', diaInfADI.incidents.v2),
        fromField('kt_unrelatedManip', diaInfADI.unrelatedManip.v2),
        {
          f: 'kt_ablated',
          t: 'Cathéters de dialyse et fistules prothèses',
          h: true
        },
        fromField('kt_ablated', diaInfADI.ablated.v2, 9),
        ...diaInfKtDistribution('D1'),
        ...diaInfKtDistribution('D2'),
        ...diaInfKtDistribution('D3')
      ]
    },
    {
      title: `Caractéristiques des infections sur site d'accès`,
      key: 'infs',
      list: [
        {
          f: 'i_infection',
          t: 'Type',
          h: true
        },
        fromField('i_infection', diaInfADI.infectionField, 9),
        fromField('i_origin', bact.bactOrigin.v2, 9),
        fromField('i_antibio', diaInfADI.antibio, 9),
        fromField(`i_covidStatus`, multi.covidStatus.std, 9),
        {
          f: `s_entrance`,
          t: `Distribution des portes d'entrée`,
          v: bact.entrance.v3.all.config.values
        }
      ]
    },
    moDistribution('i_', `infections sur site d'accès`, year),
    bactDistribution('b_', `bactériémies hors site d'accès`, { covid: true }),
    moDistribution('b_', `bactériémies hors site d'accès`, year)
  ]
}
